import * as React from 'react';
import styled from '@emotion/styled';
import { Flyout, StyledVinValidator, Magnetic as Mi } from '@mitchell/react.component.ux';
import { withI18n } from 'react-i18next';
import { DefaultVehicleSelectionLabels, vehicleSelectionHierarchy } from '../constants';
import { VehicleSelectionHierarchyLabel, VehicleSelectionMethod } from '../enums';
const VehicleSelectionMethodInput = styled('input') `
	margin-bottom: ${Mi.spacer20};
	margin-top: ${Mi.spacer32};
`;
const StyledFlyOut = styled(Flyout) `
	margin-bottom: ${Mi.spacer04};
	position: relative;
`;
export const VehicleSelectionElement = styled('div') `
	.l-vin-wrapper {
		.m-vin-decode {
			input {
			}

			input::-ms-clear {
				display: none;
			}
		}

		.m-vehicle-selection-method__label {
			user-select: none;
		}
	}
`;
export const StyledDivSpacer = styled('div') `
	margin-bottom: ${Mi.spacer20};
`;
export class VehicleSelectionUnwrapped extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isFlyoutOpened: Array(8).fill(false),
            isFlyoutLoading: Array(8).fill(false)
        };
        this.closeFlyouts = this.closeFlyouts.bind(this);
        this.toggleLoading = this.toggleLoading.bind(this);
        this.getSelectedItem = this.getSelectedItem.bind(this);
        this.onValidVin = this.onValidVin.bind(this);
        this.onInvalidVin = this.onInvalidVin.bind(this);
        this.onVinChanged = this.onVinChanged.bind(this);
        this.onSelectionMethodChanged = this.onSelectionMethodChanged.bind(this);
        this.onUpdate = this.onUpdate.bind(this);
        this.onFlyoutMenuClicked = this.onFlyoutMenuClicked.bind(this);
        this.renderFlyout = this.renderFlyout.bind(this);
        this.getMinimumContainerHeight = this.getMinimumContainerHeight.bind(this);
    }
    static getDerivedStateFromProps(props, state) {
        let isFlyoutOpened = state.isFlyoutOpened;
        let isFlyoutLoading = state.isFlyoutLoading;
        const { selectedInfoEntries } = props;
        if (props &&
            props.selectedInfoEntries &&
            props.vehicleInfoData &&
            props != VehicleSelectionUnwrapped.memoizedProps) {
            isFlyoutLoading = Array(8).fill(false);
            isFlyoutOpened = Array(8).fill(false);
            for (let i = 0; i <= 8; i++) {
                const currentHierarchyLabel = vehicleSelectionHierarchy[i];
                if (!(selectedInfoEntries.size && selectedInfoEntries.get(currentHierarchyLabel)) &&
                    props.vehicleInfoData[currentHierarchyLabel] &&
                    props.vehicleInfoData[currentHierarchyLabel].length > 1) {
                    isFlyoutOpened[i] = true;
                    break;
                }
            }
        }
        VehicleSelectionUnwrapped.memoizedProps = props;
        return {
            isFlyoutOpened,
            isFlyoutLoading
        };
    }
    render() {
        const { vehicleInfoData, isDisabled, t, shouldShowManualOption = true } = this.props;
        if (vehicleInfoData) {
            const isManualSelect = vehicleInfoData.VehicleSelectionMethod === VehicleSelectionMethod.Assisted ||
                vehicleInfoData.VehicleSelectionMethod === VehicleSelectionMethod.GenericVehicle;
            return (React.createElement(VehicleSelectionElement, { className: "l-vin-wrapper" },
                React.createElement("div", { className: "mi-font-size-03" }, t('VIN')),
                React.createElement("div", { className: "m-vin-decode" },
                    React.createElement(StyledVinValidator, { value: vehicleInfoData.Vin, onValidVin: this.onValidVin, onInvalidVin: this.onInvalidVin, onVinChanged: this.onVinChanged, id: "mi-vehicle-selection__vin-input", className: "mi-form-control", disabled: isDisabled })),
                shouldShowManualOption ? (React.createElement("div", null,
                    React.createElement(VehicleSelectionMethodInput, { id: "vehicle-selection-method-checkbox", className: "m-vehicle-selection-method", checked: isManualSelect, onChange: this.onSelectionMethodChanged, type: "checkbox", disabled: isDisabled }),
                    React.createElement("label", { htmlFor: "vehicle-selection-method-checkbox", className: "m-vehicle-selection-method__label" },
                        React.createElement("div", null, t('Manual Select'))))) : (React.createElement(StyledDivSpacer, { id: "vehicle-selection__marginSpacer" })),
                React.createElement("div", { className: "m-assisted-decode" },
                    this.renderFlyout(true, vehicleInfoData.Types, VehicleSelectionHierarchyLabel.Types, DefaultVehicleSelectionLabels.DEFAULT_TYPE_LABEL, 0),
                    this.renderFlyout(true, vehicleInfoData.Years, VehicleSelectionHierarchyLabel.Years, DefaultVehicleSelectionLabels.DEFAULT_YEAR_LABEL, 1),
                    this.renderFlyout(false, vehicleInfoData.Makes, VehicleSelectionHierarchyLabel.Makes, DefaultVehicleSelectionLabels.DEFAULT_MAKE_LABEL, 2),
                    this.renderFlyout(true, vehicleInfoData.Models, VehicleSelectionHierarchyLabel.Models, DefaultVehicleSelectionLabels.DEFAULT_MODEL_LABEL, 3),
                    this.renderFlyout(false, vehicleInfoData.SubModels, VehicleSelectionHierarchyLabel.SubModels, DefaultVehicleSelectionLabels.DEFAULT_SUBMODEL_LABEL, 4),
                    this.renderFlyout(false, vehicleInfoData.BodyStyles, VehicleSelectionHierarchyLabel.BodyStyles, DefaultVehicleSelectionLabels.DEFAULT_BODYSTYLE_LABEL, 5),
                    this.renderFlyout(false, vehicleInfoData.Engines, VehicleSelectionHierarchyLabel.Engines, DefaultVehicleSelectionLabels.DEFAULT_ENGINE_LABEL, 6),
                    this.renderFlyout(false, vehicleInfoData.Transmissions, VehicleSelectionHierarchyLabel.Transmissions, DefaultVehicleSelectionLabels.DEFAULT_TRANSMISSION_LABEL, 7),
                    this.renderFlyout(false, vehicleInfoData.DriveTrains, VehicleSelectionHierarchyLabel.DriveTrains, DefaultVehicleSelectionLabels.DEFAULT_DRIVETRAIN_LABEL, 8))));
        }
        return React.createElement("div", null);
    }
    closeFlyouts() {
        this.setState({
            isFlyoutOpened: Array(8).fill(false)
        });
    }
    toggleLoading(vehicleSelectionLabelIndex) {
        this.closeFlyouts();
        this.state.isFlyoutLoading[vehicleSelectionLabelIndex] = true;
        this.setState({
            isFlyoutLoading: this.state.isFlyoutLoading
        });
    }
    getSelectedItem(vehicleHierarchyLabel) {
        if (this.props.vehicleInfoData &&
            this.props.vehicleInfoData[vehicleHierarchyLabel.toString()] &&
            this.props.vehicleInfoData[vehicleHierarchyLabel.toString()].length === 1) {
            return this.props.vehicleInfoData[vehicleHierarchyLabel.toString()][0];
        }
        if (this.props.selectedInfoEntries.size) {
            return this.props.selectedInfoEntries.get(vehicleHierarchyLabel);
        }
        return null;
    }
    onValidVin(validVin) {
        const { onValidVinData, vehicleInfoData: vehicleInfo } = this.props;
        onValidVinData(vehicleInfo, validVin, vehicleInfo.Vid);
    }
    onInvalidVin(invalidVin) {
        const { onInvalidVinData } = this.props;
        onInvalidVinData(invalidVin);
    }
    onVinChanged(vin) {
        const { onVinUpdated, vehicleInfoData } = this.props;
        onVinUpdated(vin, vehicleInfoData.VehicleSelectionMethod);
    }
    onSelectionMethodChanged(event) {
        const { onSelectionMethodChanged, vehicleInfoData: vehicleInfo } = this.props;
        this.closeFlyouts();
        onSelectionMethodChanged(vehicleInfo, event.target.checked ? VehicleSelectionMethod.Assisted : VehicleSelectionMethod.VinDecode);
    }
    onUpdate(vehicleInfoEntry, vehicleSelectionHierarchyLabel, vehicleSelectionLabelIndex) {
        const { onFlyoutClicked, vehicleInfoData: vehicleInfo } = this.props;
        this.toggleLoading(vehicleSelectionLabelIndex);
        this.closeFlyouts();
        onFlyoutClicked(vehicleInfo, vehicleInfoEntry, vehicleSelectionHierarchyLabel, vehicleInfo.VehicleSelectionMethod);
    }
    onFlyoutMenuClicked(id) {
        const isFlyoutOpened = Array(8).fill(false);
        isFlyoutOpened[id] = !this.state.isFlyoutOpened[id];
        this.setState({
            isFlyoutOpened
        });
    }
    getMinimumContainerHeight(vehicleSelectionMethod, flyoutDataLength) {
        const FLYOUT_ITEM_MAX_HEIGHT = 49;
        const DEFAULT_FLYOUT_ITEM_LENGTH = 7;
        if (vehicleSelectionMethod === VehicleSelectionMethod.GenericVehicle) {
            const actualContainerHeight = flyoutDataLength * FLYOUT_ITEM_MAX_HEIGHT;
            const defaultContainerHeight = DEFAULT_FLYOUT_ITEM_LENGTH * FLYOUT_ITEM_MAX_HEIGHT;
            return actualContainerHeight < defaultContainerHeight ? actualContainerHeight : defaultContainerHeight;
        }
        // Set minimum container hight to undefined for other than generic vehicle.
        return undefined;
    }
    renderFlyout(shouldRenderWhenGeneric, flyoutData, hierarchyLabel, placeholderText, index) {
        const { vehicleInfoData: vehicleInfo, isDisabled, t } = this.props;
        if (vehicleInfo.VehicleSelectionMethod === VehicleSelectionMethod.GenericVehicle && !shouldRenderWhenGeneric) {
            return null;
        }
        const onFlyoutItemSelected = selectedFlyoutItem => {
            const selectedItem = this.getSelectedItem(hierarchyLabel);
            if (selectedItem &&
                selectedFlyoutItem &&
                selectedItem.Id == selectedFlyoutItem.Id &&
                selectedItem.Next == selectedFlyoutItem.Next &&
                selectedItem.Value == selectedFlyoutItem.Value) {
                this.closeFlyouts();
            }
            else {
                this.onUpdate(selectedFlyoutItem, hierarchyLabel, index);
            }
        };
        let finalPlaceholderText = placeholderText;
        let hierarchyLabelSingular = hierarchyLabel.slice(0, -1);
        if (hierarchyLabelSingular === 'Engine')
            hierarchyLabelSingular += 'Motor';
        if (vehicleInfo.Labels) {
            if (vehicleInfo.Labels[hierarchyLabelSingular]) {
                finalPlaceholderText = vehicleInfo.Labels[hierarchyLabelSingular];
            }
        }
        return (React.createElement(StyledFlyOut, { id: index, flyoutData: flyoutData, onFlyoutItemSelected: onFlyoutItemSelected, onFlyoutMenuClicked: this.onFlyoutMenuClicked, isDisabled: isDisabled || !flyoutData || flyoutData.length <= 1, selectedFlyoutItem: this.getSelectedItem(hierarchyLabel), isLoading: this.state.isFlyoutLoading[index], isVisible: this.state.isFlyoutOpened[index], displayValueForEmpty: t('Base'), placeholderText: t(finalPlaceholderText), minimumContainerHeight: this.getMinimumContainerHeight(vehicleInfo.VehicleSelectionMethod, flyoutData ? flyoutData.length : 0), className: 'mi-vehicle-flyout' }));
    }
}
export const VehicleSelection = withI18n()(VehicleSelectionUnwrapped);
//# sourceMappingURL=VehicleSelection.js.map